import passageInstruction from '../sounds/daze_passage_instructions.mp3';
import directionInstruction from '../sounds/daze_direction.mp3';
import clickOk from '../sounds/click_ok.mp3';
import scrollIntroInstruction from '../sounds/daze_scroll_intro.mp3';
import scrollDownInstruction from '../sounds/daze_scroll_down.mp3';
import scrollReadyInstruction from '../sounds/daze_ready.mp3';
import scrollInstruction from '../sounds/daze_ready_instructions.mp3';
import scrollReadyClickOk from '../sounds/daze_ready_click_ok.mp3';
import modelCorrectResponse from '../sounds/daze_model_correct_answer_selected.mp3';
import modelIncorrectResponse from '../sounds/daze_model_incorrect_answer_selected.mp3';
import modelSecondIncorrectResponse from '../sounds/daze_model_incorrect_answer_selected_twice.mp3';
import modelInstructionStart from '../sounds/daze_model_sentence_start.mp3';
import modelInstructionEnd from '../sounds/daze_model_sentence_end.mp3';
import modelOptionHome from '../sounds/daze_model_option_home.mp3';
import modelOptionSummer from '../sounds/daze_model_option_summer.mp3';
import modelOptionWas from '../sounds/daze_model_option_was.mp3';
import practiceInstruction from '../sounds/daze_practice_avatar.mp3';
import practiceIntro from '../sounds/daze_practice_intro.mp3';
import practiceEnd from '../sounds/daze_practice_sentence_end.mp3';
import practiceOptionChair from '../sounds/daze_practice_option_chair.mp3';
import practiceOptionSaw from '../sounds/daze_practice_option_saw.mp3';
import practiceOptionSleep from '../sounds/daze_practice_option_sleep.mp3';
import practiceCorrectAnswerSelected from '../sounds/daze_practice_correct_answer_selected.mp3';
import practiceIncorrectAnswerSelected from '../sounds/daze_practice_incorrect_answer_selected.mp3';
import practiceIncorrectAnswerSelectedTwice from '../sounds/daze_practice_incorrect_answer_selected_twice.mp3';
import { MODEL, PRACTICE, SCROLL } from '../constants/assessmentItemType';

export const DAZE_INSTRUCTIONS = {
    passageInstruction,
    clickOk,
    [MODEL]: {
        directionInstruction,
        modelCorrectResponse,
        modelIncorrectResponse,
        modelSecondIncorrectResponse,
        modelInstructionStart,
        modelInstructionEnd,
        modelOptionHome,
        modelOptionSummer,
        modelOptionWas,
    },
    [PRACTICE]: {
        practiceInstruction,
        practiceIntro,
        practiceEnd,
        practiceOptionChair,
        practiceOptionSaw,
        practiceOptionSleep,
        practiceCorrectAnswerSelected,
        practiceIncorrectAnswerSelected,
        practiceIncorrectAnswerSelectedTwice,
    },
    [SCROLL]: {
        scrollIntroInstruction,
        scrollDownInstruction,
        scrollReadyInstruction,
        scrollInstruction,
        scrollReadyClickOk,
    },
};

export const DAZE_PASSAGE_DEFAULT_ROW_HEIGHT = 100;
const FONT_100_PASSAGE_ROW_HEIGHT = 158;
const FONT_150_PASSAGE_ROW_HEIGHT = 189;
const FONT_200_PASSAGE_ROW_HEIGHT = 225;


export const DAZE_PASSAGE_ROW_HEIGHT_BY_FONT_SIZE = {
    100: FONT_100_PASSAGE_ROW_HEIGHT,
    150: FONT_150_PASSAGE_ROW_HEIGHT,
    200: FONT_200_PASSAGE_ROW_HEIGHT,
};
